var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import FilteringHandler from './filtering-handler';
import BaseSelectController from './base-select-controller';
var MultiselectController = /** @class */ (function (_super) {
    __extends(MultiselectController, _super);
    function MultiselectController(componentInstance) {
        var _this = _super.call(this, componentInstance) || this;
        _this.filteringHandler = new FilteringHandler(componentInstance, false);
        return _this;
    }
    MultiselectController.prototype.openDropdown = function () {
        // Reset last used focusedOption when opening
        this.component.__focusedOption = null;
        _super.prototype.openDropdown.call(this);
    };
    MultiselectController.prototype.getDefaultHighlightedOption = function () {
        if (this.shouldDisplayFilter()) {
            return null;
        }
        var selectedOptions = this.getSelectedOptions();
        if (selectedOptions.length > 0) {
            return selectedOptions[0];
        }
        return this.getEnabledOptions(true)[0];
    };
    MultiselectController.prototype.getSelectedOptions = function () {
        var _this = this;
        if (this.component.selectedOptions) {
            return this.component.selectedOptions;
        }
        if (this.component.selectedIds) {
            return this.getEnabledOptions(false).filter(function (option) { return _this.component.selectedIds.indexOf(option.id) > -1; });
        }
        return [];
    };
    MultiselectController.prototype.setSelectedOptions = function (options) {
        if (this.component.selectedOptions !== undefined) {
            this.component.selectedOptions = options;
        }
        else {
            this.component.selectedIds = options.map(function (option) { return option.id; });
        }
    };
    MultiselectController.prototype.selectOption = function (option) {
        var selectedOptions = this.getSelectedOptions();
        var alreadySelected = selectedOptions.filter(function (selected) { return option.id === selected.id; })[0];
        var deselected = alreadySelected !== undefined;
        var index = selectedOptions.indexOf(alreadySelected);
        if (this.component.keepOpen) {
            this.component.__focusedOption = option;
        }
        var newSelection = deselected
            ? __spreadArrays(selectedOptions.slice(0, index), selectedOptions.slice(index + 1, selectedOptions.length)) : __spreadArrays(selectedOptions, [option]);
        this.setSelectedOptions(newSelection);
        if (!this.component.keepOpen) {
            this.closeDropdown();
        }
        this.component.__fireEvent('change', {
            deselected: deselected,
            selectedId: option.id,
            selectedOption: option,
            selectedIds: newSelection.map(function (option) { return option.id; }),
            selectedOptions: this.getSelectedOptionsDetail(newSelection)
        });
    };
    MultiselectController.prototype.getSelectedOptionsDetail = function (newSelectedOptions) {
        if (this.component.selectedOptions) {
            // When a customer uses the new API, we provide new selected options as-is. We cannot lookup options from
            // the respective property, because it may not contain all possible selected options
            return newSelectedOptions;
        }
        // When a  customer uses for legacy selectedIds we provide options in their original order in the `options`
        // property for backward compatibility
        return this.getEnabledOptions(false).filter(function (option) { return newSelectedOptions.indexOf(option) > -1; });
    };
    MultiselectController.prototype.dismissOption = function (_a) {
        var itemIndex = _a.itemIndex;
        this.selectOption(this.getSelectedOptions()[itemIndex]);
    };
    return MultiselectController;
}(BaseSelectController));
export default MultiselectController;
//# sourceMappingURL=multiselect-controller.js.map